<script lang="ts">
    import { _ } from "svelte-i18n"
    import { createEventDispatcher } from "svelte"
    import { contentOverlay, showOfferAssistant } from "../../../store"
    import ProductInquiryExtended from "../../product/ProductInquiryExtended.svelte"
    import { tooltip } from "../../../utils"
    import { sentryEnvironment } from "../../../config"

    const dispatch = createEventDispatcher()

    type ChoiceT = {
        code: number
        label: string
        labelLong?: string
        onSelect?: Function
    }

    export let items: ChoiceT[]
    export let choice: ChoiceT
    export let imageBase: string
    export let validCodes: { [code: number]: true }
    // export let extraMargin: number = undefined

    let windowWidth = 0
    if (typeof window !== "undefined") {
        windowWidth = window.innerWidth
    }
    $: isMobile = windowWidth <= 1000
</script>

<svelte:window bind:innerWidth="{windowWidth}" />

{#if items?.length}
    <div class="mailboxfilter_types">
        {#each items as item}
            <div
                class="item"
                class:active="{choice?.code === item.code}"
                class:invalid="{validCodes && !validCodes[item.code]}"
                on:click="{() => {
                    if (choice?.code === item.code) {
                        choice = undefined
                    } else {
                        choice = item
                        dispatch('change', choice)
                        console.log(choice)
                        if (typeof choice?.onSelect == 'function') {
                            choice.onSelect()
                        }
                    }
                }}"
                use:tooltip="{item.labelLong && !isMobile ? { content: item.labelLong } : null}"
            >
                <div class="image">
                    <img
                        alt="{item.labelLong || item.label}"
                        src="{imageBase}{item.code}.svg"
                        on:error="{(e) => {
                            // @ts-ignore
                            e.target.src = '/media/sampleimage.png'
                        }}"
                    />
                </div>
                <div class="text">
                    {isMobile ? item.labelLong || item.label : item.label}
                </div>
            </div>
        {/each}

        <!-- Offer Assistant only displayed for mailboxes (not for packages), TODO master -->
        <!-- {#if window.location.pathname.includes("/individuelle-briefkastenanlagen")}
            <div class="item">
                <div class="image">
                    <img src="/media/question.svg" alt="" on:click="{() => ($showOfferAssistant = true)}" />
                </div>
                <div class="text">
                    {$_("product-config.select-not-included")}
                </div>
            </div>
        {/if} -->

        <!-- <div
            class="item search"
            on:click="{() => {
                $contentOverlay = {
                    component: ProductInquiryExtended,
                    props: {},
                }
            }}"
        >
            <div class="image"><img src="/media/question.svg" alt="" /></div>
            <div class="text">{$_('product-config.select-not-included')}</div>
        </div> -->
    </div>
{/if}

<style lang="less">
    .active {
        border: 1px solid #c4102d;
    }

    .invalid {
        opacity: 0.3;
        display: none !important;
    }
</style>
